<template>
  <Modal v-model="openForm" v-bind="$attrs" footer-hide :title="title" :draggable="draggable == false ? false : true">
    <div ref="scroll" :class="{ lylyform: overAuto }">
      <slot name="topcontent"></slot>
      <Form ref="item" class="lyform" :model="item" :rules="ruleValidate" :show-message="false"
        :label-width="labelWidth ? labelWidth : 80" :style="{ height: height ? height + 'px' : 'auto' }">
        <ul id="caculate">
          <li :class="{ active: selectName == x }" v-for="x in fffff" :key="x" @click="selectItem(x)">
            {{ x }}
          </li>
        </ul>
        <Row :gutter="16">
          <Col :span="x.span ? x.span : 12" v-for="(x, index) in forms" :key="index"
            v-show="fenlei != undefined ? x.fenlei == selectName : true">
          <FormItem :class="{ hideLabel: x.hideLabel }" :label="x.title" :prop="x.key1 ? x.key1 : x.key">
            <Input v-if="x.type == 'Input'" v-model="item[x.key]" :placeholder="x.placeholder || '请输入'" :type="x.type1"
              :rows="x.rows" :readonly="readonly || x.readonly" :disabled="x.disabled" :clearable="x.clearable"
              :maxlength="x.maxlength" :show-word-limit="x.showWordLimit"></Input>

            <InputNumber v-if="x.type == 'InputNumber'" v-model="item[x.key]" :min="x.min" :max="x.max"
              :readonly="readonly || x.readonly" :disabled="x.disabled" :clearable="x.clearable" style="width: 100%">
            </InputNumber>
            <i-switch v-model="item[x.key]" v-if="x.type == 'bool'">
              <span slot="open">{{ $t("bool.true") }}</span>
              <span slot="close">{{ $t("bool.false") }}</span>
            </i-switch>
            <RadioGroup v-model="item[x.key]" v-if="x.type == 'bool1'">
              <Radio :label="0">{{ $t("bool.false") }}</Radio>
              <Radio :label="1">{{ $t("bool.true") }}</Radio>
            </RadioGroup>
            <selectCar v-if="x.type == 'selectCar'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :id="item[x.key]" :isHand="x.isHand" :readonly="x.readonly" :clearable="x.clearable"
              @update:id="item[x.key] = $event" @car="$emit('selectCar', $event)">
            </selectCar>

            <selectGroup v-if="x.type == 'selectGroup'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :id="item[x.key]" @update:id="item[x.key] = $event">
            </selectGroup>
            <selectAddMap v-if="x.type == 'selectAddMap'" :address="item[x.key]" @update:address="item[x.key] = $event"
              :lng="item[x.keyX]" @update:lng="item[x.keyX] = $event" :lat="item[x.keyY]"
              @update:lat="item[x.keyY] = $event" :type="item[x.keyType]" @update:type="item[x.keyType] = $event"
              :readonly="x.readonly" :list1="x.list1" :list2="x.list2">
            </selectAddMap>
            <AddressList :list="item[x.key]" :list1="x.list1" :list2="x.list2" v-if="x.type == 'AddressList'"
              @update:list="item[x.key] = $event" :noUpdate="x.noUpdate" :readonly="x.readonly"></AddressList>
            <selectUser v-if="x.type == 'selectUser'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :account="item[x.key3]" @update:account="item[x.key3] = $event" :accountId="item[x.key4]"
              @update:accountId="item[x.key4] = $event" :id="item[x.key]" @update:id="item[x.key] = $event"
              :keyword="x.keyword" :isHand="x.isHand" :clearable="x.clearable">
            </selectUser>
            <selectFlow v-if="x.type == 'selectFlow'" v-model="item[x.key]"></selectFlow>
            <lyyymmdd v-if="x.type == 'lyyymmdd'" :formate="x.formate" :clearable="x.clearable" v-model="item[x.key]">
            </lyyymmdd>
            <duration v-if="x.type == 'duration'" :clearable="x.clearable" :beishu='x.beishu' v-model="item[x.key]">
            </duration>
            <ly-photo v-if="x.type == 'lyPhoto'" ref="lyphoto" v-model="item[x.key]" :one="x.one" :keep="x.keep"
              :api="x.api"></ly-photo>
            <word v-if="x.type == 'word'" ref="word" v-model="item[x.key]" :one="true" :api="x.api" :keep="x.keep">
            </word>
            <selectCity v-if="x.type == 'city'" v-model="item[x.key]" @adcode="item[x.adcode] = $event"></selectCity>
            <Select v-model="item[x.key]" style="width: 100%" v-if="x.type == 'Select'" :multiple="x.multiple"
              :readonly="x.readonly" :disabled="x.disabled" :filterable="true" :allow-create="x.allowCreate"
              @on-create="handleCreate1($event, x)" :clearable="x.clearable">
              <Avatar :src="'static/' +
                find(x.selectItems, 'id', item[x.key], 'icon') +
                '/4/3.gif'
                " slot="prefix" size="small" v-if="x.icon" />
              <Option :value="x.selectType == 'obj' ? y.id : y" v-for="(y, index1) in x.selectItems" :key="index1"
                :label="x.selectType == 'obj' ? y.name : y">
                <img :src="'static/' + y.icon + '/4/3.gif'" width="26"
                  style="float: left; margin-top: -6px; margin-right: 10px" v-if="x.icon" />
                <span>{{ x.selectType == "obj" ? y.name : y }}</span>
              </Option>
            </Select>
            <Select style="width: 100%" v-model="item[x.key]" v-if="x.type == 'Select1'">
              <Option v-for="(y, index1) in $t(x.st)" :value="index1" :key="index1">{{ x.selectType == "obj" ? y.name :
                y
                }}</Option>
            </Select>
            <CheckboxGroup @on-change="tttttttt(x.key, $event)" v-if="x.type == 'checkbox'" v-model="item[x.key]">

              <Checkbox v-for="(y, index1) in x.selectItems" :label="x.selectType == 'obj' ? y.id : y" :key="index1">
                <span v-if="x.selectType == 'obj'">{{ y.name }}</span>
              </Checkbox>

            </CheckboxGroup>
            <RadioGroup v-if="x.type == 'radio'" v-model="item[x.key]">
              <Radio v-for="(y, index1) in x.selectItems" :label="x.selectType == 'obj' ? y.id : y" :key="index1">
                <span v-if="x.selectType == 'obj'">{{ y.name }}</span>
              </Radio>

            </RadioGroup>
            <selectCarType v-if="x.type == 'selectCarType'" v-model="item[x.key]" @bbb='$emit(x.key, $event)'>
            </selectCarType>
            <selectPerson v-if="x.type == 'selectPerson'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :id="item[x.key]" @update:id="item[x.key] = $event">
            </selectPerson>
            <selectDriver v-if="x.type == 'selectDriver'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :id="item[x.key]" @update:id="item[x.key] = $event">
            </selectDriver>
            <ColorPicker v-model="item[x.key]" v-if="x.type == 'color'" />
            <slot v-if="x.slotForm" :name="x.slotForm"></slot>
          </FormItem>
          </Col>
        </Row>
      </Form>
      <slot name="endcontent"></slot>
    </div>
    <div class="formModelBottom" v-if="!readonly">
      <div class="left">
        <slot name="btnLeft"></slot>
      </div>
      <div class="right">
        <Button @click="resetForm">重置表单</Button>
        <slot name="btn"></slot>
      </div>
    </div>

  </Modal>
</template>

<script>
export default {
  props: ["labelWidth", "fenlei", "title", "height",
    "draggable", "readonly", "oldItem", "overAuto"],

  data() {
    return {
      openForm: false,
      item: {},
      ruleValidate: {},
      forms: [],
      hefa: false,
      now: 74,
      forms1: [],
      fffff: [],
      selectName: "",
      timeout: null,
    };
  },
  methods: {
    tttttttt(key, item) {
      this.$emit('checkbox', key, item);

    },
    reach(v, item) {
      this.openForm = true;
      this.forms = v;
      this.item = item;
      this.rule();
    },
    handleCreate1(x, y) {
      if (y.selectType != "obj") {
        y.selectItems.push(x);
      }
    },
    find(arr, att, val, icon) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][att] == val) {
          return arr[i][icon];
        }
      }
    },
    rule() {
      if (this.fenlei != undefined) {
        //如果需要分类，把分类放入选项卡
        var data = this.forms;

        this.fffff = [];
        for (let i = 0; i < data.length; i++) {
          if (!this.fffff.includes(data[i].fenlei)) {
            this.fffff.push(data[i].fenlei);
          }
        }
        this.selectName = this.fffff[0];
      }
      var arr = this.forms;
      var abc = {};
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].required) {
          if (arr[i].key1) {
            abc[arr[i].key1] = {
              required: true,
              message: arr[i].title + "必填",
            };
          } else {
            abc[arr[i].key] = {
              required: true,
              message: arr[i].title + "必填",
            };
          }
        }
      }
      this.ruleValidate = abc;
    },
    getItem() {
      this.check("item");
      if (this.hefa) {
        return this.item;
      } /* else {
        this.$Message.error("必填项未完善");
      } */
    },
    resetForm() {
      this.$emit('reset');
      if (this.oldItem) {
        var a = JSON.parse(JSON.stringify(this.oldItem));
        for (const i in a) {
          this.item[i] = a[i]
        }
      }
      this.$refs["item"].resetFields();

    },
    check(name) {
      this.hefa = false;
      //自己写的弹出校验
      for (const i in this.item) {
        for (const j in this.ruleValidate) {
          if (this.utils.isEmpty(this.item[j])) {
            this.$Message.error(this.ruleValidate[j].message);
            return;
          }
        }
      }
      //表单自带的校验，
      this.$refs[name].validate((valid) => {
        this.hefa = valid;
      });
    },
    close() {
      this.openForm = false;
    },
    selectItem(x) {
      this.selectName = x;
      this.$emit("tab", x);
      /* function groupBy(objectArray, property) {
        return objectArray.reduce(function (acc, obj) {
          let key = obj[property];
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {});
      } */
    },
    //滚动
    scroll(t) {
      const tbody = this.$refs.scroll;

      tbody.scrollTo({
        top: t.scroll,
        behavior: "smooth",
      });
    },

  },
  mounted() { },
  watch: {
    openForm(v) {
      if (!v) {
        this.$emit('close')
      }
    }
  }
};
</script>

<style>
.lylyform {
  height: calc(100% - 40px);
  overflow: auto;
  margin-bottom: 4px;
}

.lylyform {
  width: calc(100% - 0px);
  overflow-x: hidden;

}

.modal-center {
  background: red;

}

.modal-center .ivu-modal {
  top: 0;
}

.ivu-modal-mask {
  background-color: rgba(55, 55, 55, 0.36) !important;
}

/* .vertical-center-modal .ivu-modal-content-drag{
 top:0px;
} */

.formModelH3 {
  margin: 0 0 10px 0px;
  font-size: 1em;
  background: #e5f5fe;
  padding: 6px 10px;
}

#caculate {
  display: flex;
  margin-top: -20px;
  margin-bottom: 10px;
}

#caculate li {
  cursor: pointer;
  padding: 10px 10px 4px 10px;
}

#caculate li.active {
  border-bottom: solid 2px #1274b9;
}

.hideLabel {
  margin-bottom: 0;
}

.hideLabel label {
  display: none;
}

.hideLabel .ivu-form-item-content {
  margin-left: 0 !important;
}

.formModelBottom {
  display: flex;

}

.formModelBottom .right {
  margin-left: auto;
}

.lyform .ivu-form-item {
  margin-bottom: 10px;
  margin-top: 10px;
}

.lyform .ivu-form-item-error-tip {
  top: 5px;
  left: 6px;
  background: #fff;
  padding-right: 6px;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/formModel.vue